export default __webpack_public_path__ + "static/media/plus-icon-outline.c6c8e536.svg";